import { render, staticRenderFns } from "./BottomSheetFetchNotifications.vue?vue&type=template&id=4a7b592a&scoped=true&"
import script from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetFetchNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetFetchNotifications.vue?vue&type=style&index=0&id=4a7b592a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b592a",
  null
  
)

component.options.__file = "BottomSheetFetchNotifications.vue"
export default component.exports